import React, { useEffect } from "react";
import Layout from "../Layout";
import MyTicketlist from "../../components/mytickets/MyticketList";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { getMe } from "../../features/authSlice";

const MyTicket = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { isError, user } = useSelector((state) => state.auth);

  useEffect(() => {
    dispatch(getMe());
  }, [dispatch]);

  useEffect(() => {
    if (isError) {
      navigate("/");
    }
  }, [isError, user, navigate]);
  return (
    <Layout>
      <MyTicketlist />
    </Layout>
  );
};

export default MyTicket;
